/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-24T03:06:37.743Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeMacroAncestorsQuery', // 42
	'PageTreeMacroChildrenQuery', // 43
	'PageTreeQuery', // 44
	'PageTreeQueryWithSpaceKeyQuery', // 45
	'PermissionCheckAddCommentQuery', // 46
	'PersistentInviteEligibleQuery', // 47
	'PersonalizedTemplatesV2AllTemplatesQuery', // 48
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 49
	'PopularFeedWithTimeGranularityStorageSnippetsV2Query', // 50
	'Preferences', // 51
	'PremiumTrialEotQuery', // 52
	'ReactionsContentQuery', // 53
	'RecentlyUpdatedMacroQuery', // 54
	'RendererContentStateQuery', // 55
	'RestrictedPageWithCanViewQuery', // 56
	'ScreenQuery', // 57
	'SiteInformationQuery', // 58
	'SmartCreateFeedbackBannerQuery', // 59
	'SmartCreatePageEditorDataWrapperComponentQuery', // 60
	'SpaceNavigationQuery', // 61
	'SpaceOverviewIdQuery', // 62
	'SpaceOverviewQuery', // 63
	'SpaceOverviewSwitcherQuery', // 64
	'SpaceQuery', // 65
	'SpaceRestrictionCheckQuery', // 66
	'ThemeQuery', // 67
	'TopNavigationQuery', // 68
	'UserSettingsQuery', // 69
	'ViewSpaceExternalCollaboratorsDialogQuery', // 70
	'WebItemLocationQuery_page.metadata.banner', // 71
	'WebItemLocationQuery_system.content.byline', // 72
	'WebItemLocationQuery_system.header_left', // 73
	'WebItemLocationQuery_system.header_left_system.user', // 74
	'WebPanelLocationQuery_atl.footer', // 75
	'WebPanelLocationQuery_atl.general', // 76
	'WebPanelLocationQuery_atl.general_atl.footer', // 77
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 78
	'WebStorageCategories', // 79
	'WelcomeMessagesQuery', // 80
	'WhiteboardUnifiedQuery', // 81
	'bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 82
	'bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences', // 83
	'contentAppearanceQuery', // 84
	'contentSmartLinksORS', // 85
	'fetchMentionsProviderDataQuery', // 86
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 87
	'graphqlHelpersFetchMediaTokenQuery', // 88
	'multiMacroQueryWithAppKeyQuery', // 89
	'onboardingStateGetOnboardingStateQuery', // 90
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 91
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 92
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 93
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 94
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 95
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 96
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2', // 97
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 98
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 101
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 102
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 103
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 104
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 105
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 106
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 107
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 108
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_153', // 109
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154', // 110
	'pageButtons', // 111
	'preloadAutohighlightsQuery', // 112
	'preloadContentSmartLinksQuery', // 113
	'preloadCreateSpaceQuery', // 114
	'preloadEditButtonWithSpaceKeyQuery', // 115
	'preloadEditorNodeDataProvidersDataQuery', // 116
	'preloadForgeApps_FetchPreFilteredForgeAppsQuery', // 117
	'preloadLegacyBridgeQuery', // 118
	'preloadOperationsQuery', // 119
	'preloadPageStatusQueryDataQuery', // 120
	'preloadPersonalSpaceDetailsQuery', // 121
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 122
	'preloadSpaceBlogCountQuery', // 123
	'preloadTemplatesCollectionEligibleQuery', // 124
	'requireSuperBatchFrontendResourceRenderQuery', // 125
	'rightPanel', // 126
	'searchCombinedConfig', // 127
	'searchResults', // 128
	'shortcutsSmartLinksQuery', // 129
	'sidenavSmartLinksORS', // 130
	'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 131
	'useAnalyticsByLineQuery', // 132
	'useAudioContentQuery', // 133
	'useConfluenceStandardToPremiumExperimentQuery', // 134
	'useContentByLabelDataQuery', // 135
	'useContentClassificationContentDataClassificationQuery', // 136
	'useEditorContentModeValueQuery', // 137
	'useEmojiEverSetPropertyQuery', // 138
	'useFabricEligibilityMigrationQuery', // 139
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 140
	'useFeedTypeSelectorRefreshQuery', // 141
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 142
	'useGetCurrentStorageUsageQuery', // 143
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 144
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 145
	'useHomeWidgetStateQuery', // 146
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 147
	'useIsLoomEntryPointsEnabledQuery', // 148
	'useIsUserViewingSpaceAsAnonQuery', // 149
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 150
	'useLoomTenantProvisionStatusQuery', // 151
	'usePopularFeedWithTimeGranularityStorageQuery', // 152
	'usePreloadCommentButtonQuery', // 153
	'useReadTimeQuery', // 154
	'useRegisterAdminAnnouncementBannerQuery', // 155
	'useShareAndRestrictButtonDataQuery', // 156
	'useShortcutsSpaceNavigationQuery', // 157
	'useSpaceBaseQueryBaseQuery', // 158
	'useSpaceDetailQuery', // 159
	'useSpaceEnabledContentTypesQuery', // 160
	'useSpaceViewsDataSpaceRootQuery', // 161
	'useSpaceViewsOptionsPersistenceQuery', // 162
	'useSpacesDataAnonymousSpacesQuery', // 163
	'useSpacesDataMyVisitedSpacesQuery', // 164
	'useSpacesDataStarredSpacesQuery', // 165
	'useTitleContentPropertiesForEditorQuery', // 166
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 167
	'useTitleContentPropertiesForPublishedPageQuery', // 168
	'useUserByLicensedProductsQuery', // 169
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fa7399fffedbd6bfff9fff7f68bff7fee703', /* 134 fast, 17 slow, 10 excl */
	'prod-apne2': 'b5ff7bf7fa7399fffedbd6bfff9fff5f68bff7fee703', /* 134 fast, 16 slow, 86 excl */
	'prod-apse': 'bdff7bf7fb73b9fffedbd7bfff9fff7f69bff7feef03', /* 141 fast, 13 slow, 57 excl */
	'prod-apse2': 'bdff7ff7fa73b9fffedbd7bfff9fff7f79bff7feff03', /* 143 fast, 12 slow, 47 excl */
	'prod-apsouth': 'bdff7b77fa7399fffe5bd7bfff9fff5f79bff7fef703', /* 137 fast, 12 slow, 11 excl */
	'prod-cacentral': 'bdff7b77fbf3b9fffedbd7bfff9fff5f79bffffef703', /* 142 fast, 8 slow, 13 excl */
	'prod-east': '9fff7ff7fbf3b9fffedbd7bfffffff7f6bbffffeff03', /* 148 fast, 13 slow, 62 excl */
	'prod-eucentral': 'bfff7ff7fb73b9fffedbd6bfffbfff7f6bbff7feef03', /* 144 fast, 15 slow, 120 excl */
	'prod-eucentral2': 'addf7b37f873b9fffed3d6bdef9fff1768bff7fee701', /* 125 fast, 23 slow, 13 excl */
	'prod-euwest': 'bfff7ff7fbf3b9fffedbd7bfffbfff7f6bbffffeff03', /* 148 fast, 11 slow, 117 excl */
	'prod-euwest2': 'bdff7bf7fbf3b9fffedbd7bfff9fff5f79bffffee703', /* 142 fast, 9 slow, 18 excl */
	'prod-west2': '9dff7ff7fef3b9fffedbd7bfffbfff7f79bffffeef03', /* 145 fast, 12 slow, 53 excl */
	'stg-east': 'f6f3fb37f8ffe9effd7fd5ffde87ff7ff7bffffef703', /* 139 fast, 9 slow, 40 excl */
};
